import { createSlice } from "@reduxjs/toolkit";

import { ORDER_STATUS_CANCELLED } from "../../../constants/v3/generalConstants";

const initialState = {
  existingOrderS3ResultFileContainers: [],
  existingOrders: [],
  existingOrdersWithoutCancelled: [],
  availableKitsToOrder: [],
  uuidsOfKitsSelectedToBeOrdered: [],
  kitsJustOrderedToBeShownOnConclusionScreen: [],
  riskAssessments: [],
  hasPartialOrderFailure: false
};

export const OrderInformationSlice = createSlice({
  name: "orderInformation",
  initialState,
  reducers: {
    setExistingOrderS3ResultFileContainers: (state, { payload }) => {
      state.existingOrderS3ResultFileContainers.push(payload);
    },
    setAvailableKitsToOrder: (state, { payload }) => {
      state.availableKitsToOrder = payload;
    },
    setKitsSelectedToBeOrdered: (state, { payload }) => {
      state.uuidsOfKitsSelectedToBeOrdered = payload;
    },
    setExistingOrders: (state, { payload }) => {
      state.existingOrders = payload.data.orders;
      state.existingOrdersWithoutCancelled = payload.data.orders.filter(
        (ordered) => ordered.glOrderStatus !== ORDER_STATUS_CANCELLED
      );
    },
    setUuidsOfKitsJustOrderedToBeShownOnConclusionScreen: (
      state,
      { payload }
    ) => {
      state.kitsJustOrderedToBeShownOnConclusionScreen = payload;
    },
    setRiskAssessments: (state, action) => {
      state.riskAssessments = action.payload;
    },
    setHasPartialOrderFailure: (state, { payload }) => {
      state.hasPartialOrderFailure = payload;
    },
    reset: (state) => (state = initialState)
  }
});

export const {
  setExistingOrderS3ResultFileContainers,
  setAvailableKitsToOrder,
  setKitsSelectedToBeOrdered,
  setExistingOrders,
  setUuidsOfKitsJustOrderedToBeShownOnConclusionScreen,
  setRiskAssessments,
  setHasPartialOrderFailure,
  reset
} = OrderInformationSlice.actions;

export const selectExistingOrderS3ResultFileContainers = (state) =>
  state.order ? state.order.existingOrderS3ResultFileContainers : [];
export const selectTestKitsGLIsCurrentlyOffering = (state) =>
  state.order.availableKitsToOrder;
export const selectKitsSelectedToBeOrdered = (state) =>
  state.order && state.order.uuidsOfKitsSelectedToBeOrdered
    ? state.order.uuidsOfKitsSelectedToBeOrdered
    : [];
export const selectExistingOrders = (state) =>
  state.order && state.order.existingOrders ? state.order.existingOrders : [];
export const selectExistingOrdersWithoutCancelled = (state) =>
  state?.order?.existingOrdersWithoutCancelled ?? [];
export const selectUuidsOfKitsJustOrderedToBeShownOnConclusionScreen = (
  state
) =>
  state.order && state.order.kitsJustOrderedToBeShownOnConclusionScreen
    ? state.order.kitsJustOrderedToBeShownOnConclusionScreen
    : [];
export const selectRiskAssessments = (state) =>
  state.order && state.order.riskAssessments ? state.order.riskAssessments : [];
export const selectHasPartialOrderFailure = (state) =>
  state.order && state.order.hasPartialOrderFailure
    ? state.order.hasPartialOrderFailure
    : false;

export default OrderInformationSlice.reducer;
